import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { getPartLabels } from 'pages/MaintenancePage/components/ServiceIntervalConfigPanel/helpers/getPartLabels';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PartSelector: FunctionComponent<Props> = ({
    className = '',
    onSelect,
    options,
    selectedPart,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const partLabels = getPartLabels(t);

    return (
        <VerticalContainer className={`${styles.partSelector} ${className}`} testId={testId}>
            <Wrapper className={styles.label}>{t.LOG_SERVICE_PART}</Wrapper>

            <VerticalContainer className={styles.menu}>
                {options.map(partType => {
                    const selectedClass = partType === selectedPart ? styles.isSelected : '';

                    return (
                        <Wrapper
                            className={`${styles.menuRow} ${selectedClass}`}
                            key={partType}
                            onClick={() => onSelect({ partType })}
                            testId={`${testId}-${partType}`}>
                            {partLabels[partType]}
                        </Wrapper>
                    );
                })}
            </VerticalContainer>
        </VerticalContainer>
    );
};

export default PartSelector;
